import colombia from "./createdRow/colombia";
import mexico from "./createdRow/mexico";

const createdRow = vm => (row, data) => {
    if (vm.GLOBAL.COUNTRY === "MX") mexico(vm, row, data);
    else if (vm.GLOBAL.COUNTRY === "CO") colombia(vm, row, data);
};

export default createdRow;